<script setup lang="ts">
import { toRefs } from 'vue';

interface LoaderProps {
  size?: number;
}

const props = withDefaults(defineProps<LoaderProps>(), {
  size: 24,
});

const { size } = toRefs(props);
const viewBoxSize = `0 0 ${size.value} ${size.value}`;
</script>

<template>
  <svg class="spinner" :width="size" :height="size" :viewBox="viewBoxSize" xmlns="http://www.w3.org/2000/svg">
    <circle
      class="path"
      fill="none"
      :stroke-width="size / 6"
      stroke-linecap="round"
      :cx="size / 2"
      :cy="size / 2"
      :r="size / 2 - 3"
    ></circle>
  </svg>
</template>

<style lang="scss" scoped>
$offset: 40;
$duration: 1.5s;

.spinner {
  animation: rotator $duration linear infinite;
}

@keyframes rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
}

.path {
  stroke-dasharray: $offset;
  stroke-dashoffset: 0;
  stroke: var(--primary-300);
  transform-origin: center;
  animation: dash $duration ease-in-out infinite;
}

@keyframes dash {
  0% {
    stroke-dashoffset: $offset;
  }
  50% {
    stroke-dashoffset: $offset/4;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: $offset;
    transform: rotate(450deg);
  }
}
</style>
